const CATEGORIES_AND_SERVICES_DISPLAY_KEY_TO_SEARCH_PARAM_MAP = {
  webdesign: 'web-design',
  classicwebsite: 'classic-website',
  advancedwebsite: 'advanced-website',
  redesignsite: 'redesign-website',
  smalltasks: 'small-tasks',
  domain: 'connect-domain',
  updates: 'site-updates',
  movesite: 'migrate-website',
  mobilesite: 'mobile-website',
  siteguidance: 'website-guidance',
  installapps: 'install-apps',
  email: 'custom-email',
  pixel: 'facebook-pixel',
  analytics: 'google-analytics',
  onlinestore: 'online-store',
  ecommercesite: 'ecommerce-website-design',
  advancedstore: 'advanced-store-capabilities',
  storesettings: 'store-settings',
  storeopt: 'store-optimization',
  webdev: 'web-developer',
  codingguidance: 'coding-guidance',
  customsitefunctionalities: 'custom-site-functionalities',
  thirdpartyservices: 'third-party-services',
  contentwithdatabase: 'content-with-database',
  custominputforms: 'custom-input-forms',
  customdesign: 'custom-design-and-behavior',
  marketingandpromoting: 'marketing-promoting',
  seo: 'seo-services',
  ads: 'ad-setup',
  written: 'content-writer',
  emailmarketing: 'email-marketing',
  graphicdesign: 'graphic-designer',
  logo: 'logo-design-services',
  editimage: 'edit-image',
  visuals: 'visual-content',
  branddev: 'brand-development',
  photos: 'professional-photography',
};

const PageWidthBreakPoint = {
  Width_Tablet: '(min-width: 768px)',
  Width_1024: '(min-width: 1024px)',
  Width_1280: '(min-width: 1280px)',
  Width_1366: '(min-width: 1366px)',
  Width_1920: '(min-width: 1920px)',
};

const KeyCode = {
  Enter: 13,
  Tab: 9,
};

const PROVIDER_STATES = {
  statusType: {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    DENIED: 'DENIED',
    PUBLISHED: 'PUBLISHED',
    SUSPENDED: 'SUSPENDED',
    REMOVED: 'REMOVED',
    BANNED: 'BANNED',
  },
};

const ExpertAvailablityStatusKeys = {
  Pending: 'Pending',
  Published: 'Published',
  NotRegistered: 'NotRegistered',
  Approved: 'Approved',
  Denied: 'Denied',
  ProfileReadyToPublish: 'ProfileReadyToPublish',
  UnAvailable: 'UnAvailable',
  Hidden: 'Hidden',
  NoAutoBriefs: 'NoAutoBriefs',
  AutoBriefOn: 'AutoBriefOn',
  Preferred: 'Preferred',
};

const ExpertAvailablityStatus = {
  [ExpertAvailablityStatusKeys.Pending]: 0,
  [ExpertAvailablityStatusKeys.Published]: 1,
  [ExpertAvailablityStatusKeys.NotRegistered]: 2,
  [ExpertAvailablityStatusKeys.Approved]: 3,
  [ExpertAvailablityStatusKeys.Denied]: 4,
  [ExpertAvailablityStatusKeys.ProfileReadyToPublish]: 5,
  [ExpertAvailablityStatusKeys.UnAvailable]: 6,
  [ExpertAvailablityStatusKeys.Hidden]: 7,
  [ExpertAvailablityStatusKeys.NoAutoBriefs]: 8,
  [ExpertAvailablityStatusKeys.AutoBriefOn]: 9,
  [ExpertAvailablityStatusKeys.Preferred]: 10,
};

const LOGIN_URL =
  '//www.wix.com/signin?loginDialogContext=login&postLogin={placeholder}&postSignUp={placeholder}';
const LOGOUT_URL = '//www.wix.com/signout?redirectTo={placeholder}';

const MAX_CHARS_IN_ABOUT_SECTION = 500;
const MAX_CHARS_IN_PORTFOLIO_HOVER_DESCRIPTION = 50;
const NUM_OF_REVIEWS_IN_PROFILE_SECTION = 10;
const MAX_CHARS_IN_REVIEW_SECTION = 180;

const MIN_BUDGET = 10;
const MAX_BUDGET = 5000;
const MAX_POSSIBLE_BUDGET = 999999;
const DEFAULT_BRIEF_PARAMS = {
  entry: 'generalMenu',
  categoryId: 1,
  serviceId: 1,
  origin: 'arenahome',
};

const FILTER_TAG_PATTERNS = {
  SERVICE: 'service:',
  CATEGORY: 'category:',
  LANGUAGE: 'language:',
  BUDGET: 'budget',
  LOCATION: 'location',
};

const ARENA_BRIEF_URL = `/dynamic-brief?entry=${DEFAULT_BRIEF_PARAMS.entry}&serviceType=${DEFAULT_BRIEF_PARAMS.categoryId}&innerType=${DEFAULT_BRIEF_PARAMS.serviceId}`;
const ARENA_BRIEF_URL_CLEAN = `/dynamic-brief`;
const ARENA_BRIEF_NG_URL = `/brief/match`;
const ARENA_HOW_IT_WORKS_URL = '/how-it-works';
const ARENA_GET_HIRED_URL = '/join';
const ARENA_EXPLORE_URL = '/hire';
const ARENA_PROFILE_PAGE_URL = '/wix-partner';
const ARENA_OLD_PROFILE_PAGE_URL = '/wix-expert';
const ARENA_SMALL_TASKS_URL = '/small-tasks';
const ARENA_CONTACT_US_URL = `https://support.wix.com/_LOCALE_/wix-partners/wix-arena-for-clients`;
const ARENA_TERMS_OF_USE_URL = '/info/terms-of-use';
const WIX_TERMS_OF_SERVICE_URL = '/about/terms-of-use';
const ARENA_EXPERT_GUIDELINES_URL = '/info/expert-guidelines';
const ARENA_MY_PROFILE_URL = '/my-profile';
const ARENA_WEB_DESIGNERS_1 = '/web-designers/1';
const WIX_ON_WIX_BRIEF_PREFIX = '/general';
const EXPERT_TO_PARTNER_REDIRECT_URLS = [
  { from: `${ARENA_OLD_PROFILE_PAGE_URL}/`, to: `${ARENA_PROFILE_PAGE_URL}/` },
  { from: '/info/expert-guidelines', to: '/info/partner-guidelines' },
];
const PROFILE_PAGE_REDIRECT_URLS = [
  {
    from: `${ARENA_OLD_PROFILE_PAGE_URL}/(.*?)/.+`,
    to: `${ARENA_PROFILE_PAGE_URL}/$1`,
  },
  {
    from: `${ARENA_PROFILE_PAGE_URL}/(.*?)/.+`,
    to: `${ARENA_PROFILE_PAGE_URL}/$1`,
  },
];
const TO_WIX_ON_WIX_REDIRECT_URLS = [
  { from: '/info/partner-guidelines', to: '/partner-guidelines' },
  { from: '/info/terms-of-use', to: '/terms-of-use' },
];

module.exports = {
  PageWidthBreakPoint,
  MAX_CHARS_IN_ABOUT_SECTION,
  MAX_CHARS_IN_PORTFOLIO_HOVER_DESCRIPTION,
  NUM_OF_REVIEWS_IN_PROFILE_SECTION,
  MAX_CHARS_IN_REVIEW_SECTION,
  DEFAULT_BRIEF_PARAMS,
  WIX_BASE_URL: 'https://www.wix.com',
  WIX_MANAGE_URL: 'https://manage.wix.com',
  ARENA_BRIEF_URL,
  ARENA_BRIEF_NG_URL,
  ARENA_HOW_IT_WORKS_URL,
  ARENA_GET_HIRED_URL,
  ARENA_EXPLORE_URL,
  ARENA_PROFILE_PAGE_URL,
  ARENA_SMALL_TASKS_URL,
  ARENA_CONTACT_US_URL,
  ARENA_TERMS_OF_USE_URL,
  ARENA_EXPERT_GUIDELINES_URL,
  ARENA_MY_PROFILE_URL,
  ARENA_WEB_DESIGNERS_1,
  WIX_TERMS_OF_SERVICE_URL,
  ARENA_EXPERT_BRIEF_LIST_URL: '/brief-list',
  ARENA_EXPERT_BRIEF_LIST_IN_BIZ_MGR_URL: '/brief-list-business-manager',
  ARENA_EDIT_PROFILE_IN_BIZ_MGR_URL: '/edit-profile-business-manager',
  ARENA_EDIT_PROFILE_URL: '/edit-profile',
  ARENA_EDIT_PROFILE_TO_TAB_URL: '/edit-profile?goto=',
  ARENA_USER_BRIEF_SUMMARY_URL: '/user-brief-summary',
  ARENA_JOIN_ARENA_URL: '/join-arena',
  ARENA_JOIN_ARENA_IN_BIZ_MGR_URL: '/join-arena-business-manager',
  PARTNERS_DASHBOARD_MARKETPLACE_URL: '/partners-dashboard/marketplace',
  MIN_BUDGET,
  MAX_BUDGET,
  MAX_POSSIBLE_BUDGET,
  ExpertAvailablityStatusKeys,
  ExpertAvailablityStatus,
  PROVIDER_STATES,
  LOGIN_URL,
  LOGOUT_URL,
  FILTER_TAG_PATTERNS,
  ARENA_OLD_PROFILE_PAGE_URL,
  EXPERT_TO_PARTNER_REDIRECT_URLS,
  PROFILE_PAGE_REDIRECT_URLS,
  TO_WIX_ON_WIX_REDIRECT_URLS,
  WIX_ON_WIX_BRIEF_PREFIX,
  KeyCode,
  PAGINATION_PAGE_SIZE: 10,
  SEO_SOCIALS_IMAGE:
    '//static.wixstatic.com/media/375882_750a887236d5435cad3ce1cdc20050d6~mv2.jpg',
  CATEGORIES_AND_SERVICES_DISPLAY_KEY_TO_SEARCH_PARAM_MAP,
  PARTNERS_ACCOUNTS_SERVER:
    '/_api/partners-accounts-server/v1/partners/account',
  BASE_URL_ARENA: '/arena',
  BASE_URL_MARKETPLACE: '/marketplace',
  ARENA_REPLY_TO_REVIEW_API: '/_api/marketplace-webapp/addReplyToReview/',
  ARENA_BRIEF_URL_CLEAN,
  VISTA_PARENT_ACCOUNT: 'dd0b6be6-8bd8-4d13-8f5b-aa8368132cfb',
  VISTA_URL: 'https://99designs.com/wix',
};
